import 'apps/admin/styles/pages/organizations.scss';
import React, { Component, Fragment } from 'react';
import { Link } from 'library/util/core-router';
import Query from 'apps/admin/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';
import LoadGraphData from 'util/hoc/with-data';
import Pagination from 'library/components/pagination';
import ActiveSubscriptionsReportModal from 'apps/admin/components/active-subscriptions-report-modal';
import CreateOrganizationModal from '../components/create-organization-modal'

const GenerateReport = (props) => (
  <button style={{justifyContent: 'center'}} {...props}>
    Generate Active Subscriptions Report
  </button>
);


class Filters extends Component {
  render() {
    const {
      loading,
      data
    } = this.props;

    return (
      <div className="pairin-admin-filters">
        { resolve(data, 'organizations/pagination/total', '--') } Total
        <label>
          Filter:
          <select name="account_type" value={this.props.account_type} onChange={this.props.handleFilterUpdate} disabled={loading}>
            <option value="">All</option>
            <optgroup label="Account Type">
              <option value="business">Business</option>
              <option value="education">Education</option>
              <option value="mixed">Mixed</option>
            </optgroup>
          </select>
        </label>

        <label>
          <input onChange={this.props.handleSearch} value={this.props.search} placeholder="Search" />
        </label>
      </div>
    );
  }
}

const OrgCard = ({ id, name, settings }) => (
  <Link className={`pairin-admin-organizations-card`} data-account_type={settings.account_type} to={`/admin/organizations/${id}`}>
    { name }
    <span className="pairin-admin-organizations-card-type">
      { settings.account_type }
    </span>
  </Link>
);

class Organizations extends Component {
  state = {
    showCreateOrganizationModal: false,
    loading: false,
    search: '',
    account_type: '',
    limit: 25,
    offset: 0
  }

  mapOrgs = (org) => (
    <OrgCard key={org.id} {...org} />
  )

  handleQuery = async () => {
    this.setState({
      loading: true
    });

    try {
      const queryParams = {
        limit: this.state.limit,
        offset: this.state.offset
      };

      if (this.state.account_type) {
        queryParams.account_type = this.state.account_type;
      }
      if (this.state.search) {
        queryParams.name = this.state.search;
      }

      const result = await Query(`
          query {
            organizations (${jsonToInputParams(queryParams)}) {
              results {
                id
                settings {
                  account_type
                  assessee_product_allowed
                  free_account
                  full_curriculum
                  hiring
                  internal_pathways
                  post_assessment_report
                  primary_language
                }
                name
              }
              pagination {
                limit
                offset
                total
              }
            }
          }
      `);

      this.props.graph_update(result.data);
    } catch (e) {
      console.error('Script Error', e);
    }

    this.setState({
      loading: false
    });
  }

  handlePaginate = async (data) => {
    this.setState({
      offset: (data.limit * data.page) - data.limit,
      limit: data.limit
    }, this.handleQuery);
  }

  handleFilterUpdate = (e) => {
    const { value, name } = e.target;
    this.setState(({...nextState})=>{
      nextState[name] = value;
      nextState.offset = 0;
      return nextState;
    }, this.handleQuery);
  }

  searchTimeout = null;
  handleSearch = (e) => {
    this.setState({
      search: e.target.value,
      offset: 0
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(this.handleQuery, 500);
    });
  }

  toggleOrganizationModal = () => {
    this.setState({showCreateOrganizationModal: !this.state.showCreateOrganizationModal})
  }

  render() {
    const {
      graph_data,
      graph_loading,
      reload_graph
    } = this.props;

    const { loading, search, account_type } = this.state;

    const isLoading = graph_loading || loading;

    return (
      <Fragment>
        <CreateOrganizationModal 
          active={this.state.showCreateOrganizationModal} 
          toggleActive={this.toggleOrganizationModal}
          reloadOrganizations={this.handleQuery}
        />
        <div className="pairin-admin-header">
          <h1>{trans`Organizations`}</h1>
          <Filters handleFilterUpdate={this.handleFilterUpdate} account_type={account_type} handleSearch={this.handleSearch} loading={isLoading} data={graph_data} search={search} />
          <ActiveSubscriptionsReportModal
            component={GenerateReport}
          />
          <button onClick={this.toggleOrganizationModal}>New Organization</button>
        </div>
        <div className="pairin-admin-organizations-list">
          {
            isLoading
              ? <h1>loading...</h1>
              : resolve(graph_data, 'organizations/results', []).map(this.mapOrgs)
          }
        </div>
        <Pagination
          onPaginate={this.handlePaginate}
          page={(resolve(graph_data, 'organizations/pagination/offset', 0) / resolve(graph_data, 'organizations/pagination/limit', 1)) + 1}
          disabled={isLoading}
          {...resolve(graph_data, 'organizations/pagination', {})}
        />
      </Fragment>
    );
  }
}
Organizations.query = async (token) => (
  await Query(`
      query {
        organizations {
          results {
            id
            settings {
              account_type
              assessee_product_allowed
              free_account
              full_curriculum
              hiring
              internal_pathways
              post_assessment_report
              primary_language
            }
            name
          }
          pagination {
            limit
            offset
            total
          }
        }
      }
  `)
);

export default LoadGraphData(Organizations);
